import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
import swal from "sweetalert"
import { ecommerceService } from '../../../services/ecommerce.service'
import { cartHelper } from '../../../helpers/cart.helper'

const ItemPayMethodModal = ({ onCloseClick, method, showBalanceOnly, productPurchase }) => {
    // const dispatch = useDispatch();
    const history = useHistory();
    const [onlyOneClick, setOnlyOneClick] = useState(false)
    
    let model = {
        Products: [],
        PaymentMethodId: method.paymentMethodId
    };


    const payOrder = () => {
        if (!onlyOneClick) {
            setOnlyOneClick(true);

            if  (!showBalanceOnly)
            {
                model = {
                    Products: cartHelper.getItems(),
                    PaymentMethodId: method.paymentMethodId
                };
            }
            else {
                model.Products.push(productPurchase);
            }


                if (model.Products.length > 0 ) {
                    if (showBalanceOnly){
                         ecommerceService.payOrderExternal(model)
                        .then(function (result) {
                            if (result != undefined) {
                                if(result.responseCode !== "00")
                                {
                                    setOnlyOneClick(false);
                                    swal({ text: result.responseMessage, icon: "error" }).then(o=> {
                                        if (  result.responseCode !== "-1")
                                            window.location.href = result.data
                                    }) 
                                }
                                else{
                                    setOnlyOneClick(false);
                                    window.location.href = result.data
                                }
                            } else {
                                setOnlyOneClick(false);
                                swal({ text: "Ocurrió un error al abrir método de pago", icon: "error" })
                            }
                        });
                    }
                    else{
                        ecommerceService.payOrder(model)
                        .then(function (result) {
                            if (result != undefined) {
                                setOnlyOneClick(false);
                                if (onCloseClick != undefined) onCloseClick();
                                window.location.href = result
                            } else {
                                setOnlyOneClick(false);
                                swal({ text: "Ocurrió un error al abrir método de pago", icon: "error" })
                            }
                        });
                    }

                } else {
                    swal({ text: "No hay ningún producto en el carrito de compras", icon: "error" })
                    setOnlyOneClick(false);
                }

            }
        }

    return (
        <button
        type="button"
        className="btn secundary minimum"
        onClick={payOrder}
        >
        Pagar
        </button>
    )
}

export default ItemPayMethodModal